import useAuthWithCognito from 'hooks/useAuthWithCognito/useAuth';
import MobileNavUI from 'ui/organisms/MobileNav/MobileNav';

const MobileNav = () => {
  const { handleLogout } = useAuthWithCognito();

  return <MobileNavUI singOut={handleLogout} />;
};

export default MobileNav;
